import { render, staticRenderFns } from "./MessageDetailTab.vue?vue&type=template&id=2cadf318&scoped=true&lang=pug"
import script from "./MessageDetailTab.vue?vue&type=script&lang=ts"
export * from "./MessageDetailTab.vue?vue&type=script&lang=ts"
import style0 from "./MessageDetailTab.vue?vue&type=style&index=0&id=2cadf318&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cadf318",
  null
  
)

export default component.exports